import { PLUGIN_NOTIFICATIONS_SDK } from "embedding-sdk-bundle/components/public/notifications";

export function DashboardSubscriptionsButton() {
  return <PLUGIN_NOTIFICATIONS_SDK.DashboardSubscriptionsButton />;
}
